import { Checkbox, Modal, message, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { transformLead } from '@/services/bff/lead.api';
import type { LeadItem } from '@/services/bff/types/lead';

type LeadTransformModalProps = {
  open: boolean;
  lead?: LeadItem | null;
  onClose: () => void;
  onSuccess: () => void;
};

const { Paragraph, Text } = Typography;

export default function LeadTransformModal({
  open,
  lead,
  onClose,
  onSuccess,
}: LeadTransformModalProps) {
  const [createOpportunity, setCreateOpportunity] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setCreateOpportunity(false);
    }
  }, [open, lead?.uuid]);

  const handleSubmit = async () => {
    if (submitting) return;
    if (!lead?.uuid) {
      message.warning('缺少线索 UUID，无法转化');
      return;
    }
    try {
      setSubmitting(true);
      await transformLead(lead.uuid, {
        createOpportunity,
      });
      message.success('转化成功');
      onSuccess();
      onClose();
    } catch (error) {
      if (error instanceof Error && error.message) {
        message.error(error.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      closable={{ 'aria-label': '关闭' }}
      keyboard
      title="转化"
      open={open}
      width={560}
      confirmLoading={submitting}
      okText="保存"
      cancelText="取消"
      onOk={() => void handleSubmit()}
      onCancel={() => {
        if (!submitting) onClose();
      }}
      cancelButtonProps={{ disabled: submitting }}
      destroyOnHidden
    >
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        {lead?.sourceCustomerUuid
          ? '此线索来自商机，将复用原客户；原客户不存在或无权访问时无法转化。'
          : '转化时不校验客户、商机的必填字段，必填字段为空也支持转化。'}
      </Paragraph>
      <Space orientation="vertical" size={12} style={{ width: '100%' }}>
        <Space align="start" size={10}>
          <Checkbox checked disabled />
          <div>
            <div>{lead?.sourceCustomerUuid ? '复用原客户' : '转化为客户'}</div>
            <Text type="secondary">线索的跟进记录自动带入客户</Text>
          </div>
        </Space>
        <Checkbox
          checked={createOpportunity}
          onChange={(e) => setCreateOpportunity(e.target.checked)}
        >
          同时转化为商机
        </Checkbox>
      </Space>
    </Modal>
  );
}
